import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_DARK, GRAY} from 'ui-library/Colors';
import {Header1} from 'ui-library/Headers';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function NoSessionsCard(): JSX.Element {
  return (
    <div className={css(styles.noSessionsCardWrapper)}>
      <div className={css(styles.noSessionsCard)}>
        <BenchlingIcon icon="info-circle" className={css(styles.noSessionsCardIcon)} />
        <Header1 className={css(styles.noSessionsCardHeader)}>No sessions recorded</Header1>
        <div>
          Sessions appear when
          <br />
          apps have this feature implemented
          <br />
          and have sent data to Benchling
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  noSessionsCardWrapper: {
    color: GRAY_DARK,
    width: '100%',
    height: '800px',
    textAlign: 'center',
    paddingTop: '100px',
  },
  noSessionsCard: {
    margin: 'auto',
    width: '40%',
    fontSize: '13px',
  },
  noSessionsCardHeader: {
    fontSize: '18px',
  },
  noSessionsCardIcon: {
    color: GRAY,
    fontSize: '30px',
    marginBottom: '8px',
  },
});
